import React, { useContext } from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { Theme } from '@mui/material'
import ProductContext from '../context/ProductContext'
import { Link } from 'react-router-dom'
import { getProductUrl } from '../../../urls'
import FormattedPriceRange from '@components/FormattedPriceRange'

const useStyles = makeStyles((theme: Theme) => ({
  item: {
    border: '1px solid #d8d8d8',
    backgroundColor: '#fff',
    borderRadius: '4px',
  },
  imgWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '88px',
    height: '88px',
    borderRadius: '8px',
    overflow: 'hidden',
    '& img': {
      maxHeight: '100%',
      objectFit: 'contain',
      objectPosition: 'center',
    },
  },
  content: {
    flex: 1,
    padding: '8px 16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    rowGap: '5px',
  },
}))

const RelatedProductsCard = () => {
  const classes = useStyles()
  const { reflection } = useContext(ProductContext)

  const relatedSpecifics = reflection.product.relatedSpecifics
  if (!relatedSpecifics.length) return null
  return (
    <div className='my-30'>
      <div className='pb-16'>
        <span className='text-2xl font-medium'>Related products</span>
      </div>
      {relatedSpecifics.map(node => {
        const spec = node.specifics[0]
        if (!spec) return null
        const isSale = node.priceRange.discount.max !== node.priceRange.undiscount.max
        const priceRange = node.priceRange
        const priceCurrency = priceRange.currency
        return (
          <div key={node.id} className='mb-8'>
            <Link to={getProductUrl(spec.slug, spec.pk)} target='_blank' className='no-underline'>
              <div className={classes.item}>
                <div className='flex items-center p-8'>
                  <div className={classes.imgWrapper}>
                    <img src={node.images[0]?.thumbnailUrl} alt={spec.name} />
                  </div>
                  <div className={classes.content}>
                    <div className='text-gray text-13'>
                      {spec.categories.find(cat => cat.level === 0)?.name}
                    </div>
                    <div className='text-base font-medium mr-5 md:mr-10'>{spec.shortName}</div>
                    <div className='text-gray text-13'>
                      <div className='text-13 line-through'>
                        {!!isSale && (
                          <FormattedPriceRange
                            currency={priceCurrency}
                            minAmount={priceRange.undiscount.min}
                            maxAmount={priceRange.undiscount.max}
                          />
                        )}
                      </div>
                      <div className={`${!!isSale ? 'text-red' : 'text-black'}`}>
                        <FormattedPriceRange
                          currency={priceCurrency}
                          minAmount={priceRange.discount.min}
                          maxAmount={priceRange.discount.max}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        )
      })}
    </div>
  )
}

export default RelatedProductsCard
